import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { nextEvent } from '../../../../../../redux/authentication/actionCreator';
import './KYCCheck.scss';

function EKYCCheck() {
  const dispatch = useDispatch();

  const nextPage = () => {
    dispatch(nextEvent());
  };

  return (
    <Dialog
      open={true}
      className="error-dialog"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="dialog-content">
        <h2 style={{ textAlign: 'center' }}>Menunggu Pengesahan Profil Rakan</h2>
        <p>
          Profil anda sedang menunggu pengesahan. Sila klik butang di bawah untuk melengkapkan proses pengesahan supaya
          anda dapat meneruskan penggunaan portal ini tanpa sebarang gangguan.
        </p>
        <Button variant="contained" className="btn-dialog-loading" disabled={false} onClick={nextPage}>
          Sahkan Profil
        </Button>
      </div>
    </Dialog>
  );
}

export default EKYCCheck;
